var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCorporates(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_88039",
    "data-name": "Group 88039",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 77.88,
    height: 77.88,
    viewBox: "0 0 77.88 77.88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25596",
    "data-name": "Rectangle 25596",
    width: 77.88,
    height: 77.88,
    transform: "translate(0 0)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_88038",
    "data-name": "Group 88038",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_308434",
    "data-name": "Path 308434",
    d: "M38.94.832A20.46,20.46,0,1,1,18.493,21.291,20.453,20.453,0,0,1,38.94.832",
    fill: "#ffedd6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308435",
    "data-name": "Path 308435",
    d: "M21.488,21.292A20.456,20.456,0,0,1,40.438.887Q39.7.833,38.94.833a20.459,20.459,0,0,0,0,40.918q.756,0,1.5-.054a20.456,20.456,0,0,1-18.95-20.4",
    fill: "#fd9f28"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308436",
    "data-name": "Path 308436",
    d: "M57.162,26.876a1.252,1.252,0,0,0-1.436.781,17.981,17.981,0,0,1-16.787,11.6A2.494,2.494,0,0,0,36.451,41.6,20.459,20.459,0,0,0,58.06,28.552,1.253,1.253,0,0,0,57.162,26.876Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308437",
    "data-name": "Path 308437",
    d: "M38.94.832c5.079,0,9.2,9.16,9.2,20.459s-4.117,20.46-9.2,20.46-9.2-9.16-9.2-20.46S33.861.832,38.94.832",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308438",
    "data-name": "Path 308438",
    d: "M32.74,21.292c0-10.165,3.332-18.6,7.7-20.188a4.343,4.343,0,0,0-1.5-.271c-5.078,0-9.195,9.16-9.195,20.459s4.117,20.459,9.195,20.459a4.343,4.343,0,0,0,1.5-.271c-4.366-1.592-7.7-10.023-7.7-20.188",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308439",
    "data-name": "Path 308439",
    d: "M38.94,42.583A21.292,21.292,0,1,0,17.661,21.291,21.31,21.31,0,0,0,38.94,42.583ZM25.068,35.155a34.4,34.4,0,0,1,5.525-1.915A18.294,18.294,0,0,0,34.448,40.4,19.613,19.613,0,0,1,25.068,35.155Zm5.517-14.7a39.955,39.955,0,0,1,1.2-9.152,35.588,35.588,0,0,0,14.318,0,39.955,39.955,0,0,1,1.2,9.152Zm16.71,1.664a39.991,39.991,0,0,1-1.2,9.156,35.445,35.445,0,0,0-14.318,0,40.046,40.046,0,0,1-1.2-9.156Zm-8.355,18.8c-2.707,0-5.163-3.206-6.7-8.054a33.8,33.8,0,0,1,13.4,0c-1.539,4.847-3.995,8.052-6.7,8.052m4.492-.52a18.287,18.287,0,0,0,3.855-7.156,34.366,34.366,0,0,1,5.522,1.915A19.615,19.615,0,0,1,43.432,40.4M53.991,8.718a19.6,19.6,0,0,1,0,25.146,35.893,35.893,0,0,0-6.25-2.211,41.44,41.44,0,0,0,1.22-9.53h6.267a.832.832,0,0,0,0-1.664H48.96a41.365,41.365,0,0,0-1.221-9.528,36.038,36.038,0,0,0,6.252-2.213m-1.18-1.29a34.5,34.5,0,0,1-5.524,1.918,18.325,18.325,0,0,0-3.855-7.163,19.612,19.612,0,0,1,9.379,5.245M38.94,1.664c2.708,0,5.165,3.207,6.7,8.058a33.813,33.813,0,0,1-13.408,0c1.54-4.851,4-8.058,6.7-8.058m-4.492.52a18.313,18.313,0,0,0-3.855,7.162,34.533,34.533,0,0,1-5.524-1.918,19.618,19.618,0,0,1,9.379-5.244M19.325,21.291A19.544,19.544,0,0,1,23.89,8.718a35.921,35.921,0,0,0,6.252,2.213,41.418,41.418,0,0,0-1.222,9.528H23.984a.832.832,0,0,0,0,1.664H28.92a41.5,41.5,0,0,0,1.22,9.53,35.952,35.952,0,0,0-6.25,2.211,19.546,19.546,0,0,1-4.565-12.573",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308440",
    "data-name": "Path 308440",
    d: "M23.8,55.241H4.16A3.328,3.328,0,0,0,.833,58.569V77.048h26.3V58.569A3.328,3.328,0,0,0,23.8,55.241Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308441",
    "data-name": "Path 308441",
    d: "M7.156,55.241h-3A3.328,3.328,0,0,0,.832,58.569V77.048h3V58.569A3.328,3.328,0,0,1,7.156,55.241Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308442",
    "data-name": "Path 308442",
    d: "M13.981,69.934,9.6,65.094l2.242-9.853h4.282l2.242,9.853Z",
    fill: "#ffedd6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308443",
    "data-name": "Path 308443",
    d: "M12.593,64.594l2.129-9.353H11.84L9.6,65.093l4.383,4.841,1.723-1.9Z",
    fill: "#fd9f28"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308444",
    "data-name": "Path 308444",
    d: "M23.8,54.409H4.161A4.165,4.165,0,0,0,0,58.569V77.048a.832.832,0,0,0,.832.832h26.3a.831.831,0,0,0,.832-.832V58.569A4.164,4.164,0,0,0,23.8,54.409Zm2.5,21.807H1.664V58.569a2.5,2.5,0,0,1,2.5-2.5H10.8L8.787,64.909a.831.831,0,0,0,.2.743l4.383,4.84a.836.836,0,0,0,1.233,0l4.383-4.84a.833.833,0,0,0,.195-.743l-1.512-6.644a.832.832,0,0,0-1.623.369l1.416,6.222-3.476,3.838-3.475-3.838,2-8.783H23.8a2.5,2.5,0,0,1,2.5,2.5Z",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308445",
    "data-name": "Path 308445",
    d: "M13.981,52.065a7.724,7.724,0,1,0-7.72-7.724,7.731,7.731,0,0,0,7.72,7.724",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308446",
    "data-name": "Path 308446",
    d: "M64.678,77.048H48.284V49.372a1.662,1.662,0,0,1,1.662-1.662h13.07a1.662,1.662,0,0,1,1.662,1.662Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308447",
    "data-name": "Path 308447",
    d: "M52.608,47.71H49.945a1.662,1.662,0,0,0-1.661,1.662V77.048h2.663V49.372a1.661,1.661,0,0,1,1.661-1.662",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308448",
    "data-name": "Path 308448",
    d: "M59.586,43.353h-6.21a1.664,1.664,0,0,0-1.664,1.664V47.71H61.25V45.017a1.664,1.664,0,0,0-1.664-1.664",
    fill: "#ffedd6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308449",
    "data-name": "Path 308449",
    d: "M53.376,43.353a1.664,1.664,0,0,0-1.664,1.664V47.71h2.5V43.353Z",
    fill: "#fd9f28"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308450",
    "data-name": "Path 308450",
    d: "M75.11,77.048H64.678V54.42h8.771a1.662,1.662,0,0,1,1.661,1.662Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308451",
    "data-name": "Path 308451",
    d: "M48.284,77.048H37.852V56.083a1.662,1.662,0,0,1,1.661-1.663h8.771Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308452",
    "data-name": "Path 308452",
    d: "M53.5,67.936a.831.831,0,0,0-.832.832v1.569a.832.832,0,0,0,1.664,0V68.768a.831.831,0,0,0-.832-.832",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308453",
    "data-name": "Path 308453",
    d: "M53.5,60.3a.831.831,0,0,0-.832.832V62.7a.832.832,0,0,0,1.664,0V61.131A.831.831,0,0,0,53.5,60.3",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308454",
    "data-name": "Path 308454",
    d: "M53.5,52.842a.831.831,0,0,0-.832.832v1.569a.832.832,0,0,0,1.664,0V53.674a.831.831,0,0,0-.832-.832",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308455",
    "data-name": "Path 308455",
    d: "M59.462,67.936a.831.831,0,0,0-.832.832v1.569a.832.832,0,1,0,1.664,0V68.768a.831.831,0,0,0-.832-.832",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308456",
    "data-name": "Path 308456",
    d: "M59.462,60.3a.831.831,0,0,0-.832.832V62.7a.832.832,0,1,0,1.664,0V61.131a.831.831,0,0,0-.832-.832",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308457",
    "data-name": "Path 308457",
    d: "M59.462,52.842a.831.831,0,0,0-.832.832v1.569a.832.832,0,1,0,1.664,0V53.674a.831.831,0,0,0-.832-.832",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308458",
    "data-name": "Path 308458",
    d: "M77.048,76.216h-1.1V56.083a2.5,2.5,0,0,0-2.494-2.495H65.51V49.372a2.5,2.5,0,0,0-2.493-2.494h-.935V45.017a2.5,2.5,0,0,0-2.5-2.5h-6.21a2.5,2.5,0,0,0-2.5,2.5v1.861h-.934a2.5,2.5,0,0,0-2.494,2.494v4.216H39.513a2.5,2.5,0,0,0-2.493,2.495V76.216H35.914a.832.832,0,1,0,0,1.664H77.048a.832.832,0,1,0,0-1.664ZM69.894,63.532a.833.833,0,0,1-.832-.832V61.131a.832.832,0,0,1,1.664,0V62.7a.832.832,0,0,1-.832.832m.832,5.236v1.57a.832.832,0,0,1-1.664,0v-1.57a.832.832,0,0,1,1.664,0M52.544,45.017a.833.833,0,0,1,.832-.832h6.21a.833.833,0,0,1,.832.832v1.861H52.544ZM43.068,67.936a.833.833,0,0,1,.832.832v1.57a.832.832,0,1,1-1.664,0v-1.57a.832.832,0,0,1,.832-.832M42.236,62.7V61.131a.832.832,0,1,1,1.664,0V62.7a.832.832,0,1,1-1.664,0m21.61,13.516H49.116V49.372a.83.83,0,0,1,.829-.83H63.016a.831.831,0,0,1,.83.83Z",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308459",
    "data-name": "Path 308459",
    d: "M7.154,30.214a1.165,1.165,0,1,1-1.167,1.165,1.166,1.166,0,0,1,1.167-1.165",
    fill: "#fd9f28"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308460",
    "data-name": "Path 308460",
    d: "M7.119,28.028a.832.832,0,0,0,.832-.832V18.514h3.5l-1.187.971a.833.833,0,0,0,1.054,1.289l2.991-2.448a.838.838,0,0,0-.007-1.294l-2.991-2.39a.832.832,0,0,0-1.039,1.3l1.136.908H7.119a.833.833,0,0,0-.832.832V27.2A.833.833,0,0,0,7.119,28.028Z",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308461",
    "data-name": "Path 308461",
    d: "M34.634,50.648,33.5,49.74h9.934a.832.832,0,1,0,0-1.664H33.455l1.186-.971a.832.832,0,0,0-1.053-1.288L30.6,48.264a.838.838,0,0,0,.007,1.294l2.991,2.39a.832.832,0,1,0,1.039-1.3Z",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308462",
    "data-name": "Path 308462",
    d: "M63.557,18.515h4.219v9.633l-.906-1.135a.832.832,0,0,0-1.3,1.038l2.389,2.993a.838.838,0,0,0,1.294.007L71.7,28.059a.832.832,0,1,0-1.288-1.053l-.97,1.186V17.683a.831.831,0,0,0-.832-.832H63.557a.832.832,0,1,0,0,1.664Z",
    fill: "#515255"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorporates);
export default __webpack_public_path__ + "static/media/Corporates.fd78d38f25299902f145a6bcfca488ea.svg";
export { ForwardRef as ReactComponent };